module.exports = __webpack_public_path__ + "img/saml.0132dc0d.svg";